// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___Xpu5n","text":"text___YW17Y","size":"size___FAtlU"};